/**
 * White-label branding. Override via build env or `window.__COVOMO_BRAND__` (set before app bundle loads).
 */
declare global {
  interface Window {
    __COVOMO_BRAND__?: {
      brandName?: string;
      supportEmail?: string;
      supportUrl?: string;
      partnerEmail?: string;
    };
  }
}

function env(key: string): string | undefined {
  if (typeof process !== "undefined" && process.env?.[key]) {
    return process.env[key];
  }
  return undefined;
}

function fromWindow<K extends keyof NonNullable<Window["__COVOMO_BRAND__"]>>(
  key: K,
): string | undefined {
  if (typeof window === "undefined") return undefined;
  const w = window.__COVOMO_BRAND__;
  const v = w?.[key];
  return typeof v === "string" && v.trim() !== "" ? v : undefined;
}

/** Display name (e.g. shown in footer, marketing copy). */
export const brandName: string =
  fromWindow("brandName") ?? env("VUE_APP_BRAND_NAME") ?? "Covomo";

/** Customer support / contact email. */
export const supportEmail: string =
  fromWindow("supportEmail") ??
  env("VUE_APP_SUPPORT_EMAIL") ??
  "service@covomo.de";

/** Help center / support portal URL. */
export const supportUrl: string =
  fromWindow("supportUrl") ??
  env("VUE_APP_SUPPORT_URL") ??
  "https://support.covomo.de/support/home";

/** Broker / pool contact (header widget fallback). */
export const partnerEmail: string =
  fromWindow("partnerEmail") ??
  env("VUE_APP_PARTNER_EMAIL") ??
  "partner@covomo.de";

/** Transactional “from” address for system emails (e.g. comparison share). */
export const transactionalFromEmail: string =
  env("VUE_APP_TRANSACTIONAL_FROM_EMAIL") ?? "postmaster@eu.covomo.de";
